import React from "react";
import { NavLink } from "react-router-dom";
import PageHero from "../components/PageHero";
import ImageGallery from "../components/ImageGallery";

function SafetyTabs() {
  return (
    <div className="category-tabs">
      <NavLink end to="/safety-barriers">
        Overview
      </NavLink>
      <NavLink to="/safety-barriers/specifications">
        Specifications
      </NavLink>
      <NavLink to="/safety-barriers/projects">
        Projects
      </NavLink>
    </div>
  );
}

/* ---------- OVERVIEW ---------- */

function SafetyBarriersOverview() {
  return (
    <div className="page">
      <PageHero
        title="Safety Barriers & Doors"
        subtitle="Physical protection systems for equipment, walkways and critical zones."
        imagePlaceholder="Safety Barrier Systems"
      />
      <SafetyTabs />

      <section className="section">
        <h2>Applications</h2>
        <div className="two-column">
          <ul className="list">
            <li>Factory aisles & walkways</li>
            <li>Loading bays & dock edges</li>
            <li>Machine guarding & enclosures</li>
            <li>Warehouse racking protection</li>
          </ul>
          <p className="muted">
            Safety barriers and impact-resistant doors protect people and assets
            from vehicle movements and accidental impact. ROOFTECH provides
            systems configured to the impact rating, traffic pattern and layout
            of each facility.
          </p>
        </div>
      </section>
    </div>
  );
}

/* ---------- SPECIFICATIONS ---------- */

export function SafetyBarriersSpecs() {
  return (
    <div className="page">
      <PageHero
        title="Safety Barriers – Specifications"
        subtitle="Engineered barrier systems designed for specific impact ratings and safe operation."
        imagePlaceholder="Barrier Details / Sections"
      />
      <SafetyTabs />

      <section className="section">
        <h2>System Highlights</h2>
        <div className="spec-grid">
          <div>
            <h3>Barrier Types</h3>
            <p>
              Guard rails, bollards, column protectors, dock barriers and
              pedestrian handrails, tailored to site layout.
            </p>
          </div>
          <div>
            <h3>Materials</h3>
            <p>
              Heavy-duty powder-coated steel, high-visibility polymer systems or
              hybrid solutions, selected to match impact levels.
            </p>
          </div>
          <div>
            <h3>Fixing & Foundations</h3>
            <p>
              Anchored to concrete with engineered baseplates and fasteners,
              designed to transfer loads safely.
            </p>
          </div>
          <div>
            <h3>Integration</h3>
            <p>
              Compatible with doors, dock levellers, roller shutters and access
              control for safe, controlled movements.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ---------- PROJECTS ---------- */

export function SafetyBarriersProjects() {
  const galleryItems = [
    { label: "Forklift Aisle Barrier" },
    { label: "Dock Edge Protection" },
    { label: "Column Guards" },
    { label: "Machine Enclosure" },
    { label: "Pedestrian Rail" }
  ];

  return (
    <div className="page">
      <PageHero
        title="Safety Barriers – Projects"
        subtitle="Installed across warehouses, factories and logistics hubs to protect people and assets."
        imagePlaceholder="Installed Barriers"
      />
      <SafetyTabs />

      <section className="section">
        <h2>Sample Use Cases</h2>
        <div className="card-grid">
          <div className="card">
            <h3>Warehouse Aisles</h3>
            <p>
              Dual-rail barriers separating forklift traffic from pedestrian
              walkways, with clear visual guidance.
            </p>
          </div>
          <div className="card">
            <h3>Loading Bay Edges</h3>
            <p>
              Heavy-duty dock barriers preventing accidental vehicle roll-off at
              dock edges.
            </p>
          </div>
          <div className="card">
            <h3>Machine Guarding</h3>
            <p>
              Perimeter barriers and doors around high-speed machinery to create
              safe operating zones.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Project Gallery</h2>
        <p className="muted" style={{ marginBottom: "0.8rem" }}>
          Click any image tile to open a larger view of the barrier layout.
        </p>

        <ImageGallery items={galleryItems} />
      </section>
    </div>
  );
}

export default SafetyBarriersOverview;
